export type VehiclePhotoPositionDTO = {
  fileId: string;
  position: number;
};
